import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-149adc27"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "broken-image-container" };
const _hoisted_2 = { class: "broken-image-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageFileQuestion = _resolveComponent("ImageFileQuestion");
    const _component_FriedH3 = _resolveComponent("FriedH3");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ImageFileQuestion, { class: "broken-image-icon" }),
            _createVNode(_component_FriedH3, { class: "broken-image-title" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('Oops..')), 1)
                ]),
                _: 1
            }),
            _createVNode(_component_FriedParagraph, { class: "broken-image-description" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('could-not-load-image')), 1)
                ]),
                _: 1
            })
        ])
    ]));
}
